import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", y = 30 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal for hero headings
export function MaskLine({ children, delay = 0, className = "" }) {
  return (
    <span className="reveal-mask">
      <motion.span
        className={`block ${className}`}
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1, delay, ease: [0.77, 0, 0.175, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
}
